const invalidDomains = [
    'gamil.com',
    'gail.com',
    'email.com',
    'yaoo.com',
    'gma.com',
    'outlook.co',
    'sncglobal.net',
    'gmail.co',
    'yahoo.co',
    'gmai.com',
    'ail.com',
    'gmsil.com',
    'gnail.com',
    'gamail.com',
    'gmaill.com',
    'gmaol.com',
    'gmaul.com',
    'gmal.com',
    'gmail.cm',
    'gmail.col',
    'gmail.om',
    'gmail.xom',
    'gmil.com',
    'gmial.com',
    'gmmail.com',
    'hmail.com',
    'hitmail.com',
    'hormail.com',
    'cloud.com',
    'iclod.com',
    'iclou.com',
    'icloud.com',
    'iclould.com',
    'ivloud.com',
    'tahoo.com',
    'yahoo.cm',
    'yaho.com',
    'yahooo.com',
    'yanoo.com',
    'yshoo.com',
];

const invalidTLDs = [
    'con',
    'ccom',
    'cim',
    'clm',
    'co',
    'comb',
    'come',
    'comi',
    'coml',
    'comm',
    'comp',
    'comr',
    'coms',
    'comt',
    'comu',
    'coma',
    'comb',
    'comc',
    'comd',
    'comn',
    'coms',
    'cpm',
    'vom',
];

/**
 * Check if email is a valid format and type
 * @param {string} email - The email entered into the text field
 * @example
 * const isValidEmail = validEmail('sally@gmai.com');
 * @return {boolean} whether or not it is a valid email
 */
export const validEmail = (email) => {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValidEmail = emailRegex.test(String(email).toLowerCase());

    if (!isValidEmail) return false;

    const domain = email.split('@').pop();
    const tld = domain.split('.').pop();

    return !invalidDomains.includes(domain) && !invalidTLDs.includes(tld);
};
